import { useState, useContext, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import { toast } from 'react-toastify';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { FaAddressCard } from 'react-icons/fa';
import { AuthContext } from '../../contexts/auth';

export default function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('123456'); // Senha padrão
  const [name, setName] = useState('');
  const [genero, setGenero] = useState('');
  const [dataNasc, setDataNasc] = useState('');
  const [celular, setCelular] = useState('');

  const [cidade, setCidade] = useState([]);
  const [cargo, setCargo] = useState([]);
  const [igreja, setIgreja] = useState([]);

  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [cargoSelecionado, setCargoSelecionado] = useState('');
  const [igrejaSelecionada, setIgrejaSelecionada] = useState('');

  const { signUp, loadingAuth } = useContext(AuthContext);

  useEffect(() => {
    const getCidadeFromDatabase = async () => {
      try {
        const cidadeSnapshot = await getDocs(collection(db, 'Cidade'));
        const cidadeData = cidadeSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCidade(cidadeData);
      } catch (error) {
        console.error('Erro ao buscar cidade:', error);
      }
    };

    const getCargoFromDatabase = async () => {
      try {
        const cargoSnapshot = await getDocs(collection(db, 'Cargo'));
        const cargoData = cargoSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCargo(cargoData);
      } catch (error) {
        console.error('Erro ao buscar cargo:', error);
      }
    };

    const getIgrejaFromDatabase = async () => {
      try {
        const igrejaSnapshot = await getDocs(collection(db, 'Igreja'));
        const igrejaData = igrejaSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setIgreja(igrejaData);
      } catch (error) {
        console.error('Erro ao buscar igreja:', error);
      }
    };

    getCidadeFromDatabase();
    getCargoFromDatabase();
    getIgrejaFromDatabase();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();

    // Define a senha padrão se o campo de senha estiver vazio
    const finalPassword = password === '' ? '123456' : password;

    if (name && email && finalPassword && genero && cidadeSelecionada && cargoSelecionado && igrejaSelecionada) {
      const userData = {
        email,
        password: finalPassword,
        name,
        genero,
        celular,
        datanasc: dataNasc,
        cargo: cargoSelecionado,
        cidade: cidadeSelecionada,
        igreja: igrejaSelecionada,
      };

      await signUp(userData); // Passar todos os dados do usuário para a função signUp

      setName('');
      setEmail('');
      setPassword('123456'); // Resetar senha padrão
      setGenero('');
      setDataNasc('');
      setCelular('');
      setCargoSelecionado('');
      setIgrejaSelecionada('');
      setCidadeSelecionada('');
    } else {
      toast.error('Preencha todos os campos!');
    }
  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name="Usuario">
          <FaAddressCard size={25} />
        </Title>

        <div className="container">
          <form onSubmit={handleSubmit}>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome completo"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <label>Número do Celular</label>
            <input
              type="number"
              placeholder="Número do Celular"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
            />

            <label>Gênero</label>
            <select value={genero} onChange={(e) => setGenero(e.target.value)}>
              <option value="" disabled>Selecione</option>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
            </select>

            <label>Data de Nascimento</label>
            <input
              type="date"
              value={dataNasc}
              onChange={(e) => setDataNasc(e.target.value)}
            />

            <label>Cidade</label>
            <select
              value={cidadeSelecionada}
              onChange={(e) => setCidadeSelecionada(e.target.value)}
            >
              <option value="">Selecione uma cidade</option>
              {cidade.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>{cidade.nome}</option>
              ))}
            </select>

            <label>Cargo</label>
            <select
              value={cargoSelecionado}
              onChange={(e) => setCargoSelecionado(e.target.value)}
            >
              <option value="">Selecione um cargo</option>
              {cargo.map((cargo) => (
                <option key={cargo.id} value={cargo.id}>{cargo.nome}</option>
              ))}
            </select>

            <label>Casa de Oração</label>
            <select
              value={igrejaSelecionada}
              onChange={(e) => setIgrejaSelecionada(e.target.value)}
            >
              <option value="">Selecione uma Casa de Oração</option>
              {igreja.map((igreja) => (
                <option key={igreja.id} value={igreja.id}>{igreja.nome}</option>
              ))}
            </select>

            <label>Username</label>
            <input
              type="text"
              placeholder="Username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              style={{ display: 'none' }}
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button type="submit">
              {loadingAuth ? 'Carregando...' : 'Cadastrar'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
